export const boldGrowthMeetup = {
  '@context': 'https://schema.org',
  '@type': 'Event',
  name: 'Bold Growth Meetup',
  startDate: '2023-09-26T18:30:00+02:00',
  endDate: '2023-09-26T21:30:00+02:00',
  duration: 'PT3H',
  description:
    'This meetup will inspire you to take user-centricity from an undefined concept to an actionable product strategy. Implement the techniques from the talks and align your business goals with the user value creation. Expert product practitioners from Boldare and Growth Tribe guide you towards accelerated growth in users and revenue.',
  location: {
    '@type': 'Place',
    name: 'Amsterdam Growth Tribe',
    address: {
      '@type': 'PostalAddress',
      addressCountry: 'NL',
    },
  },
  organizer: {
    '@type': 'Organization',
    name: 'Boldare',
    url: 'https://www.boldare.com',
  },
  performer: [
    {
      '@type': 'Person',
      name: 'Oskar Kwitek',
      jobTitle: 'Product Strategist',
      affiliation: {
        '@type': 'Organization',
        name: 'Boldare',
      },
    },
    {
      '@type': 'Person',
      name: 'Tarek Reslan',
      jobTitle: 'Lead Growth & Marketing Trainer & Coach',
      affiliation: {
        '@type': 'Organization',
        name: 'Growth Tribe',
      },
    },
  ],
  maximumAttendeeCapacity: 50,
};
